import React, { useState, useCallback, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  Select,
  SelectItem,
  Checkbox,
} from 'carbon-components-react';
import { Tooltip as ReactTooltip } from "react-tooltip";

import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const handleChange = () => {

    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    json["version"] = document.getElementById("version_id").value;

    var yamlop = jsonToYaml(json);

    window.iagyaml = yamlop;
};

const VersionPage = () => {

    const idPrefix = "";

  if(window.iagpage != "VersionPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "VersionPage";
  }

    const [version, setversion] = useState('""'),
    updateversion = useCallback((evt) => setversion(evt.target.value), []);

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }
      setversion((json && json.version)?json.version:"");

    };

    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Version
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}></h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div className="bx--col">
                <br/><br/><br/>
                <div className="iag--simple-div">
                <div className= {"iag_form_elem version_div" + idPrefix}>
                <Select
                  value={version}
                   id={"version_id" + idPrefix}
                  labelText="Version"
                  onChange={(evt) => {updateversion(evt); handleChange();}}>
                  <SelectItem text="" value="" />
                  <SelectItem text="19.12" value="19.12" />
                  <SelectItem text="20.01" value="20.01" />
                  <SelectItem text="20.04" value="20.04" />
                  <SelectItem text="20.07" value="20.07" />
                  <SelectItem text="20.09" value="20.09" />
                  <SelectItem text="20.12" value="20.12" />
                  <SelectItem text="21.02" value="21.02" />
                  <SelectItem text="21.04" value="21.04" />
                  <SelectItem text="21.06" value="21.06" />
                  <SelectItem text="21.09" value="21.09" />
                  <SelectItem text="21.12" value="21.12" />
                  <SelectItem text="22.07" value="22.07" />
                  <SelectItem text="23.04" value="23.04" />
                  <SelectItem text="23.1" value="23.1" />
                  <SelectItem text="24.03" value="24.03" />
                  <SelectItem text="24.06" value="24.06" />
                  <SelectItem text="24.09" value="24.09" />
                  <SelectItem text="24.12" value="24.12" />
                  <SelectItem text="25.03" value="25.03" />
                  <SelectItem text="25.06" value="25.06" />
                  <SelectItem text="25.09" value="25.09" />
                  <SelectItem text="25.12" value="25.12" />
                  <SelectItem text="26.03" value="26.03" />
                  <SelectItem text="26.06" value="26.06" />
                  <SelectItem text="26.09" value="26.09" />
                </Select>
                </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    );
};

export default VersionPage;
